import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

import { VColor } from '../../modules/sanna/data/models/constants.interface';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private toastController: ToastController) {}

  /**
   * Despliega mensaje en pantalla (Toaster)
   *
   * @param message - Texto a mostrar
   * @param duration - Tiempo en milisegundos
   * @param color - Color de fondo. Posibles valores:
   * 'primary' | 'secondary' | 'tertiary' | 'success' | 'warning' | 'danger' | 'light' | 'medium' | 'dark'
   */
  async present(message: string = ':)', duration: number = 5000, color: VColor = 'dark') {
    const params = {
      message,
      duration,
      color,
      buttons: [
        {
          icon: 'close',
          role: 'cancel',
          handler: () => {
            // close clicked
          },
        },
      ],
    };
    const toast = await this.toastController.create(params);
    toast.present();
  }
}
